import { update } from 'state/util';
import { STATUS } from 'state/requestStatus/reducer';
import { makeVotePrefKey } from 'state/votePrefs/reducer';
import { parseCandidatePageId } from 'state/ballots/position';

const initialState = {};
export const ballotsReducer = (state=initialState, action) => {
  if (action.type === "LOGOUT_REQUESTED")
      return initialState;

  let key = null;
  let currentData = null;
  let currentVotePrefsData = null;
  if (action.payload && action.payload.userId) {
    key = `ballot#${action.payload.userId}`;
    currentData = state[key] ? state[key].data : {};
    currentVotePrefsData = state[key] ? state[key].votePrefsData : [];
  }

  // update the vote pref in the ballot
  if (
    action.type ===  "WRITE_VOTE_PREF_SUCCESSFUL" &&
    currentVotePrefsData && currentVotePrefsData.length
  ) {
    const newVP = action.payload;
    const newVPKey = makeVotePrefKey(newVP.pageId, newVP.userId);
    // for checking/updating candidate vote prefs
    const newCandPos = parseCandidatePageId(newVP.pageId);
    const votePrefsWithSaved = currentVotePrefsData.map((vp) => {
      const thisKey = makeVotePrefKey(vp.pageId, vp.userId)
      if (thisKey === newVPKey) {
        return newVP;
      }
      // if this is a prop or a prop was saved, we just return
      // the existing data from the state tree. we only want to update
      // state tree candidate pages if we just saved a candidate
      const thisCandPos = parseCandidatePageId(vp.pageId);
      if (!newCandPos || !thisCandPos) {
        return vp;
      }
      const thisPosition = thisCandPos[1];
      const thisCandidate = thisCandPos[2];
      const newPosition = newCandPos[1];
      // skip non-saved positions, we only update the other position
      // vote prefs matching the one saved
      if (thisPosition !== newPosition) {
        return vp;
      }
      // we have a non-yes position to update for this vote pref
      if (newVP.position[thisCandidate]) {
        return Object.assign({}, vp, {
          data: { vote: newVP.position[thisCandidate] }
        });
      }
      // we know some other candidate for this position is "yes"
      // so that means this has to be no, now
      else if (newVP.position.yes !== thisCandidate) {
        return Object.assign({}, vp, {
          data: { vote: "N" }
        });
      }
      return vp;
    });
    return update(state, {
      [key]: {
        votePrefsData: votePrefsWithSaved,
      }
    });
  }

  switch(action.type) {
    // using "WRITE" because create/update are same
    case "WRITE_BALLOT_REQUESTED":
      return update(state, {
        [key]: {
          message: "Saving...",
          status: STATUS.SAVING,
        },
      });

    case "WRITE_BALLOT_SUCCESSFUL":
      return update(state, {
        [key]: {
          data: action.payload.data,
          votePrefsData: action.payload.votePrefsData,
          votePrefs: action.payload.votePrefs,
          user: action.payload.user,
          message: "Save successful",
          status: STATUS.COMPLETE,
        },
      });

    case "WRITE_BALLOT_FAILED":
      return update(state, {
        [key]: {
          message: action.payload.message,
          status: STATUS.FAILED,
        },
      });

    case "GET_BALLOT_REQUESTED":
      return update(state, {
        [key]: {
          data: currentData || {},
          votePrefsData: currentVotePrefsData || [],
          message: "Loading page...",
          status: STATUS.LOADING,
        },
      });

    case "GET_BALLOT_SUCCESSFUL":
      return update(state, {
        [key]: {
          data: action.payload.data,
          votePrefsData: action.payload.votePrefsData,
          votePrefs: action.payload.votePrefs,
          user: action.payload.user,
          message: null,
          status: STATUS.COMPLETE,
        },
      });

    case "GET_BALLOT_FAILED":
      if (action.payload.statusCode === 404) {
        // return a blank vote pref for creating if not found
        return update(state, {
          [key]: {
            message: null,
            data: {},
            votePrefsData: [],
            votePrefs: [],
            status: STATUS.NOT_FOUND,
          },
        }, true);
      }
      return update(state, {
        [key]: {
          message: action.payload.message,
          status: STATUS.FAILED,
        },
      });

    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/state/ballots/reducer.js